// extracted by mini-css-extract-plugin
module.exports = {"customSelectSecondary":"CustomSelectSecondary_customSelectSecondary__r4pfh","title":"CustomSelectSecondary_title__Ln6Ks","chevronDown":"CustomSelectSecondary_chevronDown__dkQPF"};